export default 'controlCenterApp';
